import {
  DefaultButton,
  IDropdownOption,
  Modal,
  PrimaryButton,
} from '@fluentui/react';
import { X } from '@phosphor-icons/react';
import {
  DownloadModalContent,
  DownloadModalFooter,
  DownloadModalHeader,
  SelectWrapper,
  modalStyles,
} from './styles';
import { Checkbox, FluentProvider } from '@fluentui/react-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DownloadModalProps {
  isOpen: boolean;
  format: string;
  closeModal: () => void;
  setFormat: (format: string) => void;
  onDownload: (includeText: boolean, separateAudios: boolean) => void;
}

export const DownloadModal = ({
  isOpen,
  closeModal,
  format,
  setFormat,
  onDownload,
}: DownloadModalProps) => {
  const formatOptions: IDropdownOption[] = [
    { key: '8-wav', text: '8KHz (.WAV)' },
    { key: '16-wav', text: '16KHz (.WAV)' },
    { key: '24-wav', text: '24KHz (.WAV)' },
    { key: '48-wav', text: '48KHz (.WAV)' },
    { key: '16-mp3', text: '16KHz (.MP3)' },
    { key: '24-mp3', text: '24KHz (.MP3) - Default' },
    { key: '48-mp3', text: '48KHz (.MP3)' },
    { key: '16-ogg', text: '16KHz (.OGG)' },
    { key: '24-ogg', text: '24KHz (.OGG)' },
    { key: '48-ogg', text: '48KHz (.OGG)' },
  ];

  const [includeText, setIncludeText] = useState(false);
  const [separateAudios, setSeparateAudios] = useState(false);

  const { t } = useTranslation('myapps');

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={closeModal}
      isBlocking={false}
      containerClassName={modalStyles.container}
    >
      <DownloadModalContent>
        <DownloadModalHeader>
          <h1>{t('TTS_DOWNLOAD_MODAL_TITLE')}</h1>
          <h2>{t('TTS_DOWNLOAD_MODAL_SUBTITLE')}</h2>
          <X className="closeModal" size={24} onClick={closeModal} />
        </DownloadModalHeader>

        <SelectWrapper>
          <span>{t('TTS_DOWNLOAD_MODAL_FORMATS_LABEL')}</span>
          <select
            name="download-formats"
            onChange={(ev) => setFormat(ev.target.value)}
          >
            {formatOptions.map((item) => {
              return (
                <option
                  key={'audio-format-' + item.key}
                  value={item.key}
                  selected={item.key === format}
                >
                  {item.text}
                </option>
              );
            })}
          </select>
        </SelectWrapper>
        <FluentProvider>
          <Checkbox
            checked={includeText}
            onChange={() => setIncludeText(!includeText)}
            label={t('TTS_DOWNLOAD_MODAL_INCLUDE_TEXT')}
          />
          <Checkbox
            checked={separateAudios}
            onChange={() => setSeparateAudios(!separateAudios)}
            label={t('TTS_DOWNLOAD_MODAL_SEPARATE_PARAGRAPHS')}
          />

          <DownloadModalFooter>
            <PrimaryButton
              onClick={() => {
                closeModal();
                onDownload(includeText, separateAudios);
              }}
              text={t('TTS_DOWNLOAD_MODAL_DOWNLOAD_BUTTON')}
            />
            <DefaultButton
              onClick={() => closeModal()}
              text={t('TTS_DOWNLOAD_MODAL_CLOSE_BUTTON')}
            />
          </DownloadModalFooter>
        </FluentProvider>
      </DownloadModalContent>
    </Modal>
  );
};
